var DB_NAME = "bengali_app";
export default DB_NAME;

export const brand_name = "BongGo";
export const website_name = "bonggo.app";
export const operator_name = "Mr. Saptarshi Mondal";
export const grievance_officer_name = "Mr. Saptarshi Mondal";
export const grievance_email = "support@bonggo.app";
export const adsense_client_id = "ca-pub-7168291691366659";
